var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[_c('iframe',{staticClass:"w-full h-full",attrs:{"src":`${_vm.currentEnv.VUE_APP_RUN_PAGE}`,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }